import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { first, getOr, isEmpty } from 'lodash/fp';
import {
  getIsFetched,
  getIsFetching,
  getSmtpAccounts,
  getActiveSmtpAccounts
} from '../redux/Settings/selectors/portal/smtp-account';
import {
  SMTP_TYPES,
  SmtpAccountStatus,
  SmtpAccountConnectionState
} from '../constants/smtp-account';
import { fetchSmtpAccounts } from '../redux/Settings/sagas/portal/smtp-account/routines';

export const useSmtpAccounts = () => {
  const dispatch = useDispatch();
  const isFetched = useSelector(getIsFetched);
  const isFetching = useSelector(getIsFetching);
  const accounts = useSelector(getSmtpAccounts);
  const activeAccounts = useSelector(getActiveSmtpAccounts);
  const smtpAccount = first(accounts) || {};
  const isConnected = Number(getOr(0, 'isConnected', smtpAccount)) === 1;
  const smtpStatus = Number(getOr(0, 'status', smtpAccount));
  const showDisconnectedMessage =
    !isEmpty(smtpAccount) &&
    Number(isConnected) === SmtpAccountConnectionState.DISCONNECTED &&
    Number(smtpStatus) === SmtpAccountStatus.INACTIVE;
  const lastAuthError = getOr(null, 'lastAuthError', smtpAccount);
  const hasAccounts = accounts.length > 0;
  const hasActive = activeAccounts.length > 0;

  useEffect(
    () => {
      if (!isFetched && !isFetching) {
        dispatch(fetchSmtpAccounts({ type: SMTP_TYPES.GMAIL }));
      }
    },
    [isFetched, isFetching]
  );

  return {
    isFetched,
    isFetching,
    accounts,
    smtpAccount,
    activeAccounts,
    showDisconnectedMessage,
    lastAuthError,
    hasAccounts,
    hasActive
  };
};
